// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__4uaqr","title":"Header_title__3OyJa","side":"Header_side__1YPbc"};